<template lang="pug">

  div
    div(v-if='show && attributeName!="mineral_mohs_hardness"', :class="'SearchRefinementList SearchRefinementList-'+listType")
      slot(name='header')
      div(v-for='facet in displayFacetValues', :key='facet.name', :class="'SearchRefinementList_item' + (facet.isRefined ? ' is-active' : '')")
        label.SearchRefinementList_itemLabel
          input.SearchRefinementList_itemCheckbox(type='checkbox', v-model='facet.isRefined', @change='toggleRefinement(facet)', :value='facet.name')
          slot(:count='facet.count', :active='facet.isRefined', :value='facet.name')
            span.SearchRefinementList_itemName(v-if="listType === 'buttons'") {{ $t('sample.types.sample--' + facet.name) }}
            span.SearchRefinementList_itemColorBullet(v-else-if="groupName === 'color'", :style="'background-color: ' + facet.name +''")
            span.SearchRefinementList_itemName(v-else) {{ facet.name }}
      .SearchRefinementList_item(v-if='hasMore', key='hasMore', @click='withLimit = false')
        label.SearchRefinementList_itemMore
          slot
            span.SearchRefinementList_itemName ...
      slot(name='footer')


    div(v-if='show && attributeName=="mineral_mohs_hardness"')
      SearchRangeSlider(:attributeName="attributeName")




</template>

<script>
import { Component } from 'vue-instantsearch'
import SearchRangeSlider from '@/components/SearchRangeSlider'

export default {
  mixins: [Component],
  components: {
    SearchRangeSlider
  },
  props: {
    listType: {
      type: String,
      default: 'rows',
      validator (value) {
        return value === 'buttons' || value === 'rows'
      }
    },
    attributeName: {
      type: String,
      required: true
    },
    groupName: {
      type: String,
      required: false,
      default: ''
    },
    operator: {
      type: String,
      // default: Store.FACET_OR
      // validator (rawValue) {
      //   const value = rawValue.toLowerCase()

      //   return value === Store.FACET_OR || value === Store.FACET_AND
      // }
    },
    limit: {
      type: Number,
      default: 5
    },
    sortBy: {
      default () {
        return ['isRefined:desc', 'count:desc', 'name:asc']
      }
    }
  },
  data () {
    return {
      withLimit: true
    }
  },
  created() {
    this.searchStore.addFacet(this.attributeName, this.operator)
  },
  destroyed () {
    this.searchStore.stop()
    this.searchStore.removeFacet(this.attributeName)
    this.searchStore.start()
  },
  computed: {
    facetValues () {
      return this.searchStore.getFacetValues(
        this.attributeName,
        this.sortBy,
        this.withLimit ? this.limit + 1 : 100000000
      )
    },
    displayFacetValues () {
      return this.searchStore.getFacetValues(
        this.attributeName,
        this.sortBy,
        this.withLimit ? this.limit : 100000000
      )
    },
    hasMore () {
      return this.facetValues.length > this.limit && this.withLimit
    },
    show () {
      return this.facetValues.length > 0
    }
  },
  methods: {
    toggleRefinement (value) {
      return this.searchStore.toggleFacetRefinement(
        this.attributeName,
        value.name
      )
    }
  },
  watch: {
    operator () {
      this.searchStore.addFacet(this.attributeName, this.operator)
    }
  }
}
</script>

<style lang="stylus" scoped>

// Pour tous les types
.SearchRefinementList

  .is-active

    .SearchRefinementList_itemColorBullet

      border-color $beige

  &_itemLabel

    position relative

  &_itemColorBullet

    position absolute
    top 50%
    left 24px
    border 1px solid transparent
    transition border-color 0.6s $ease
    transform translateY(-50%)
    border-radius 50%
    width: 22px;
    height: 22px;
    margin: 0 10px;

  .SearchRefinementList_itemCheckbox
    position: absolute
    top 0
    left 0
    opacity: 0

// Rows type
.SearchRefinementList-rows

  .SearchRefinementList_item
    margin-top -1px // HACK - comme ça on boit qu'une seule des 2 bordures lorsque 2 éléments se suivent

    &.is-active
      .SearchRefinementList_itemLabel
        &::before
          background-color $beige
      .SearchRefinementList_itemName
        opacity: 1

    &:hover

      .SearchRefinementList_itemName

        letter-spacing 1.4px

  .SearchRefinementList_itemLabel,
  .SearchRefinementList_itemMore

    cursor: pointer
    height 50px
    display: flex
    flex-direction row
    justify-content: flex-start
    align-items: center
    color $beige
    text-transform: uppercase
    font-size 1rem
    line-height 1rem
    transition all 0.8s $ease
    border-width 1px 0 1px
    border-color $black
    border-style solid
    padding-left 25px

    &:hover
      .SearchRefinementList_itemName
        opacity: .8

    // circle
    &::before
      content ''
      display: inline-block
      width 18px
      height: @width
      border-radius (@width/2)
      border 1px solid $beige
      margin 0 10px
      opacity .3
      transition all .8s $ease

    .SearchRefinementList_itemName
      opacity: .5
      transition all 0.8s $ease

  .SearchRefinementList_itemMore::before
    visibility hidden

  &:hover

    .SearchRefinementList_itemLabel:before

      opacity 1!important

// Buttons type
.SearchRefinementList-buttons
  display flex
  flex-wrap wrap
  margin 0 auto
  max-width: 400px
  flex-direction row
  justify-content: center
  align-items: flex-start

  .SearchRefinementList_item
    position: relative
    display inline-block
    width 100%
    max-width 165px
    cursor: pointer
    margin: 10px

    &:hover

    .SearchRefinementList_item

      .SearchRefinementList_itemLabel:before, .SearchRefinementList_itemName

        opacity 1!important

    @media $mq_s_only

      width calc(50% - 20px)

    &.is-active
      .SearchRefinementList_itemLabel
        &::before
          background-color $beige
          opacity 0.35!important
      .SearchRefinementList_itemName
        opacity: 1

  .SearchRefinementList_itemLabel
    display: flex
    height labelHeight = 40px
    justify-content: center
    align-items: center
    transition all 0.6s $ease
    border-radius: (labelHeight/2)
    cursor: pointer

    &::before
      content ''
      position: absolute
      top 0
      left 0
      right 0
      bottom 0
      transition all 0.8s $ease
      border 1px solid $beige
      border-radius: (labelHeight/2)
      opacity: .3

  .SearchRefinementList_itemName
    color: $beige
    text-transform: uppercase
    font-size 16px
    line-height @font-size
    opacity: .5
    transition all 0.8s $ease

</style>
